export const RESET_PASSWORD_MODAL_NAME = 'resetPassword';
export const BRAND_CHOOSE_MODAL_NAME = 'brandChoose';
export const ADD_EDIT_USER_MODAL_NAME = 'addEditUser';
export const SIMPLE_TABLE_MODAL_NAME = 'simpleTable';
export const SIMPLE_CONFIRM_MODAL_NAME = 'simpleConfirm';
export const FITMENT_DUPLICATE_MODAL_NAME = 'fitmentDuplicate';
export const EXPORT_DOWNLOADS_MODAL_NAME = 'exportDownloads';
